import { useSyncExternalStore } from 'react';
import { getCompareIds, subscribeCompare } from './compareStore';

/** 비교함 React 바인딩 — 어디서든 현재 비교 대상 id 목록 구독 */
export function useCompare(): number[] {
  return useSyncExternalStore(subscribeCompare, getCompareIds, () => []);
}
